<template>
  <div>
    <b-table
      :items="dataTable.rows"
      :fields="dataTable.fields"
      :busy="loading"
      class="col-12 mt-2 table-views"
      show-empty
    >
      <template #empty>
        <div class="text-center my-2">
          <h2>Sin datos para mostrar</h2>
        </div>
      </template>
      <template #cell(type)="row">
        <div class="">
          <div
            class="d-flex align-items-center"
            v-if="
              row.item?.characterization_code !== '' &&
              row.item?.characterization_code !== null
            "
          >
            <span class="status" :style="'color:' + row.item?.type?.textcolor">
              <img
                v-if="row.item?.type?.icon"
                class="centerImg1 mr-1"
                :src="require('@/assets/images/icons/' + row.item?.type?.icon)"
                width="20px"
              />
              {{ row.item?.type?.text }}
            </span>
            <div
              v-if="
                row.item?.sve === 'Respiratorio' ||
                row.item?.sve === 'Desordenes Musculo Esqueléticos'
              "
            >
              <button
                class="button-table-employee"
                @click.prevent="riskPotentialEdit(row?.item)"
                v-b-tooltip.hover
                title="Editar"
              >
                <span class="icon-pencil centerImg1 resaltar"> </span>
              </button>
            </div>
          </div>
          <button
            @click.prevent="riskPotential(row?.item)"
            class="btn_risk_potential"
            v-else-if="
              row.item?.sve === 'Respiratorio' ||
              row.item?.sve === 'Desordenes Musculo Esqueléticos'
            "
          >
            Realizar riesgo potencial
          </button>
          <span v-else> N/A </span>
        </div>
      </template>
      <!-- VerRegistro -->
      <template #cell(view)="row">
        <div class="d-flex justify-content-center">
          <button
            class="button-table-employee"
            @click.prevent="findItem(row.item.id)"
            :id="`tooltip-button-ver-${row.item.id}`"
          >
            <img
              class="centerImg1 resaltar"
              :src="require('@/assets/images/icons/eye-line.svg')"
            />
          </button>

          <button
            class="button-table-employee"
            @click.prevent="() => $emit('editGes', row.item)"
            :id="`tooltip-button-edit-${row.item.id}`"
          >
            <span class="icon-pencil centerImg1 resaltar"> </span>
          </button>

          <button
            class="button-table-employee"
            :id="`tooltip-button-delete-${row.item.id}`"
            @click.prevent="
              () => $emit('deleteItem', row.item.id, row.item.name)
            "
          >
            <img
              class="centerImg1 resaltar icondelete"
              :src="require('@/assets/images/icons/delete-bin-2-line.svg')"
            />
          </button>

          <b-tooltip :target="`tooltip-button-ver-${row.item.id}`" placement="top" custom-class="custom-tooltip-ht">
            Ver GES
          </b-tooltip>
          <b-tooltip :target="`tooltip-button-edit-${row.item.id}`" placement="top" custom-class="custom-tooltip-ht">
            Editar GES
          </b-tooltip>
          <b-tooltip :target="`tooltip-button-delete-${row.item.id}`" placement="top" custom-class="custom-tooltip-ht">
            Eliminar GES
          </b-tooltip>
        </div>
      </template>
      <template #cell(view3)>
        <span style="cursor: pointer">
          <img
            class="centerImg1 mr-1"
            :src="require('@/assets/images/icons/ht_icon_eye.svg')"
            @click.prevent="() => $emit('onRowSelected', row - selected)"
          />
        </span>
      </template>
      <template #table-busy>
        <div class="text-center my-2 mb-3">
          <overlay-button></overlay-button>
        </div>
      </template>
    </b-table>

    <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
      <Pagination
        v-if="!loading"
        :data="tableGES"
        :limit="15"
        @pagination-change-page="loadRowsPag"
      ></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "laravel-vue-pagination";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import { mapState } from "vuex";

export default {
  components: {
    Pagination,
    OverlayButton,
  },
  props: {
    dataTable: {
      type: Object,
      default: () => {
        return {};
      },
    },
    loading: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    category: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("modSVE", ["tableGES"]),
  },
  methods: {
    loadRowsPag(page) {
      const me = this;
      me.$emit("loadRowsPag", page);
    },
    findItem(id) {
      const me = this;
      me.$router.push({
        name: "detailSve",
        params: { id: id, category: me.category, type: me.type, ipt: "0" },
      });
    },
    riskPotential(item) {
      const me = this;
      me.$router.push({
        name: "formRisk",
        params: { id: item?.id, category: me.category, type: me.type },
      });
    },
    riskPotentialEdit(item) {
      const me = this;
      me.$router.push({
        name: "editFormRisk",
        params: {
          id: item?.id,
          category: me.category,
          type: me.type,
          is_edit: true,
        },
      });
    },
  },
};
</script>

<style lang="css">
.button-table-employee {
  border: none;
  background-color: white;
}

.btn_risk_potential {
  background-color: white;
  border: 1px solid #5d5fef;
  border-radius: 8px;
  padding: 10px;
  font-size: 16px;
  color: #5d5fef;
}

.custom-tooltip-ht .tooltip-inner {
  max-width: 200px !important;
  background-color: #263238 !important;
  font-size: 14px !important;
}
</style>
